import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import "../scss/main.scss";

import "../components/slider-swiper";
import { variantOnChange } from "../components/variants-product";
import '../components/slidershow';
import '../components/faq';
import '../components/collection-card';
import { openCloseModal } from "../components/product-modal";
import { renderElements } from "../components/product-modal";
import { setQuantity } from "../utils/input-quantity";
import { listenButtonAddresses } from "../components/addresses";
import { captureMenu } from "../components/megamenu";
import {
  openCloseMenu,
  readDataActive,
  changeItem
} from '../components/display-menu';
import { filterToggle } from '../components/filters';
import { toggleDataActive } from '../utils/toggle-dataset';
import {
  btnAddToCart,
  deleteItem,
  onChangeItemCart,
  openCloseCart
} from "../components/cart";
import { loginPage } from '../components/login';

captureMenu();
openCloseMenu();
readDataActive();
changeItem();

variantOnChange('.variants');
renderElements();
openCloseModal();

btnAddToCart(".add-product-cart");
btnAddToCart(".add-product-cart-modal");

openCloseCart();
deleteItem();
setQuantity(".quantity-product");
onChangeItemCart();
loginPage();
listenButtonAddresses();
filterToggle(".details-toggle");
toggleDataActive(
  ".button-search",
  "#search",
  { overlay: true }
);




